import { actionField } from '../../../../topics'
import { hasActionField } from './has-action-field'

export const doesCtaRepresentGift = (ctaType = '') =>
  hasActionField(ctaType) && ctaType === actionField.gifting
